import { Section } from "../ui/Section";
import { Eyebrow } from "../ui/Eyebrow";
import { H2, Highlight } from "../ui/Heading";
import { DashedCard } from "../ui/DashedCard";
import { StatusPill } from "../ui/StatusPill";
import { PRIVACY_LINES } from "../data/privacy";
import { LINKS } from "../data/links";
import { PrivacyFlow } from "./PrivacyFlow";

export function Privacy() {
  return (
    <Section id="privacy">
      <Eyebrow n="07">Privacy</Eyebrow>
      <H2 className="max-w-[920px]">
        Built for chats you <Highlight>can't afford to leak</Highlight>.
      </H2>
      <p className="mt-4.5 max-w-[640px] text-xl italic text-td-2">
        The Telegram you have. Plus the memory you wish you had. Without the
        data risk.
      </p>

      <div className="mt-14 grid grid-cols-2 gap-12 max-md:grid-cols-1 max-md:gap-9">
        <div className="grid grid-cols-2 gap-3.5 max-[560px]:grid-cols-1">
          {PRIVACY_LINES.map((line) => (
            <DashedCard key={line.tag} hover={false} className="p-5 flex flex-col">
              <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-accent">
                {line.tag}
              </div>
              <div className="mt-3 text-sm leading-relaxed text-td-2">
                {line.body}
              </div>
            </DashedCard>
          ))}
        </div>
        <PrivacyFlow />
      </div>

      <div className="mt-12 flex gap-3 flex-wrap items-center">
        <StatusPill color="good">Firecracker microVM per user</StatusPill>
        <StatusPill color="good">AES-GCM encrypted vault</StatusPill>
        <StatusPill color="good">WorkOS SSO (Enterprise)</StatusPill>
        <a
          href={LINKS.trust}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 border border-dashed border-dash-d font-mono text-[11px] uppercase tracking-wider text-td-2 hover:text-td-1 hover:border-accent transition-colors"
        >
          <span className="size-1.5 rounded-full bg-accent" />
          Read the trust doc →
        </a>
      </div>
    </Section>
  );
}
